import { MenuItem, useTheme } from '@mui/material';
import { forwardRef } from 'react';

import { getDropdownItemDisplayValue, getDropdownItemIcon } from '../helpers';
import { useDropdownLocators } from '../hooks/useDropdownLocators';
import { type DropdownListItem } from '../types';

export type DropdownMenuItemProps = {
  id: string;
  key: string;
  option: DropdownListItem;
  value: string | null;
  index: number;
};

export const DropdownMenuItem = forwardRef<HTMLLIElement, DropdownMenuItemProps>(
  ({ id, option, value, key, ...rest }, ref) => {
    const theme = useTheme();
    const { ariaDropdownMenuItem } = useDropdownLocators({ key });

    if (option.divider) {
      return (
        <MenuItem
          {...rest}
          ref={ref}
          key={key}
          divider
          disabled
          sx={{
            borderColor: '#d3d4d7',
            borderWidth: 1,
            padding: 0,
          }}
          role="separator"
          aria-label={ariaDropdownMenuItem}
        />
      );
    }

    const icon = getDropdownItemIcon(option, 16);
    const displayValue = getDropdownItemDisplayValue(option);

    return (
      <MenuItem
        {...rest}
        ref={ref}
        key={key}
        value={option.value}
        disabled={option.disabled}
        selected={option.value === value}
        sx={{
          color: theme.palette.text.primary,

          '&:hover': {
            opacity: 1,
          },
        }}
        role="menuitem"
        aria-label={ariaDropdownMenuItem}
        aria-disabled={option.disabled}
      >
        {icon}&nbsp;{displayValue}
      </MenuItem>
    );
  }
);
